import { render } from "./dialogAyudaTurnarOficios.vue?vue&type=template&id=33e893c1&scoped=true"
import script from "./dialogAyudaTurnarOficios.vue?vue&type=script&lang=js"
export * from "./dialogAyudaTurnarOficios.vue?vue&type=script&lang=js"

import "./dialogAyudaTurnarOficios.vue?vue&type=style&index=0&id=33e893c1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e893c1"]])

export default __exports__